<template>
  <v-container class="px-0">
    <v-card flat class="mt-5">
      <v-card-title class="px-0">
        <span class="headline">{{
          isNew ? "Novo usuário" : "Editar usuário"
        }}</span>
      </v-card-title>
      <v-card-text class="px-0">
        <v-form ref="userForm" :value="userFormValid">
          <v-row wrap class="px-0">
            <v-col class="col-xs-12 col-sm-12 col-md-4">
              <p class="mb-1">Login</p>
              <v-text-field
                dense
                v-model="formData.UserName"
                outlined
                placeholder="Usado para acesso ao sistema"
                :rules="[formRules.requiredField, formRules.notSpaceChar]"
                :blur="
                  (formData.UserName = formData.UserName
                    ? formData.UserName.replaceAll(' ', '')
                    : formData.UserName)
                "
                :disabled="!isNew"
              ></v-text-field>
              <!-- , formRules.notSpaceChar -->
            </v-col>
            <v-col class="col-xs-12 col-sm-12 col-md-8">
              <p class="mb-1">Nome completo</p>
              <v-text-field
                dense
                v-model="formData.Nome"
                outlined
                placeholder="Nome e sobrenome"
                :rules="[formRules.requiredField, formRules.validName]"
              ></v-text-field>
            </v-col>
            <v-col class="col-xs-12 col-sm-12 col-md-4">
              <p class="mb-1">E-mail</p>
              <v-text-field
                dense
                v-model="formData.Email"
                outlined
                placeholder="E-mail de contato"
                :rules="[formRules.requiredField, formRules.validEmail]"
                :blur="
                  (formData.Email = formData.Email
                    ? formData.Email.replaceAll(' ', '')
                    : formData.Email)
                "
              ></v-text-field>
            </v-col>
            <v-col class="col-xs-12 col-sm-12 col-md-4" v-if="showPhone">
              <p class="mb-1">Telefone</p>
              <v-text-field
                dense
                v-model="formData.PhoneNumber"
                outlined
                v-mask="
                  formData.PhoneNumber && formData.PhoneNumber.length < 15
                    ? '(##) ####-#####'
                    : '(##) #####-####'
                "
                :masked="true"
                placeholder="(00) 0000-0000"
              ></v-text-field>
            </v-col>

            <v-col class="col-xs-12 col-sm-12 col-md-2" v-if="shouldShowDisalbePasswordLoginSwitch">
              <p class="mb-1">Desabilitar login com senha</p>
                 <v-switch
                  class="smallSwitch mt-0"
                  v-model="formData.IsPasswordLoginDisabled"
                  color="primary"
                  hide-details
                  style="font-size: 14px;"
                ></v-switch>
            </v-col>

            <v-col class="col-xs-12 col-sm-12 col-md-2" v-if="shouldShowMFASwitch">
              <p class="mb-1">Exigir MFA</p>
                 <v-switch
                  class="smallSwitch mt-0"
                  v-model="formData.IsMFARequired"
                  color="primary"
                  hide-details
                  style="font-size: 14px;"
                ></v-switch>
            </v-col>
            
            <v-col class="col-xs-12 col-sm-12 col-md-4">
              <p class="mb-1">Prestadores</p>
              <v-autocomplete
                :items="prestadoresList"
                item-text="prest_nome"
                item-value="id"
                v-model="formData.Prestadores"
                label="Selecione"
                :rules="formRules.requiredAutoComplete"
                solo
                dense
                outlined
                flat
                multiple
                chips
                small-chips
                :search-input.sync="searchInput"
                >
                <template v-slot:prepend-item>
                  <v-list-item ripple @click="toggleAllPrestadores">
                    <v-list-item-content>
                      <v-list-item-title>{{
                        isAllSelected ? "NENHUM" : "TODOS"
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:selection="data">
                  <span v-if="isAllSelected && data.index == 0">TODOS</span>
                  <v-chip
                    v-if="!isAllSelected && data.index < 2"
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    close-icon="fa-times"
                    @click="data.select"
                    @click:close="remove(data.item)"
                    >{{ data.item.prest_nome }}</v-chip
                    >
                  <span v-if="!isAllSelected && data.index == 2">
                    + {{ formData.Prestadores.length - 2 }}
                    {{
                      formData.Prestadores.length - 2 == 1 ? "outro" : "outros"
                    }}</span
                  >
                </template>

                <template v-slot:item="data">
                  <v-list-item
                    @click="toggleAutocomplete(data.item, 'Prestadores')"
                    :class="
                      formData.Prestadores.includes(data.item.id)
                        ? 'primary--text v-list-item--active'
                        : ''
                    "
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{
                        data.item.prest_nome
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>
            <!-- <v-col>
              <v-switch
              class="smallSwitch mt-0"
                  v-model="statusUser"
                  :label="IsActive?'Usuário ativo':'Usuário inativo'"
                  color="primary"
                  hide-details
                  @change="beforeToogleStatus"
                ></v-switch>
        </v-col> -->
            <v-col class="col-xs-4 col-sm-4 col-md-4">
              <p class="mb-1">Permissões</p>
              <span>{{ profileText }}</span>
              <UsersProfilesForm
              :editButton="true"
              :isNew="isNew"
              :openForm="() => (showProfileDialog = true)"
              :closeForm="(profile) => closeProfileForm(profile)"
              :dialog="showProfileDialog"
              :item="
                  JSON.stringify({
                    UsuarioTradimus: formData.UsuarioTradimus,
                    Permissao: formData.Permissao,
                  })
                "
              />
              <div class="v-text-field__details" v-if="invalidProfile">
                <div class="v-messages theme--light error--text" role="alert">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      Configure o perfil do usuário.
                    </div>
                  </div>
                </div>
              </div>
            </v-col>

            <v-col class="col-xs-12 col-sm-12 col-md-4" v-if="shouldShowGeneratePasswordButton">
              <p class="mb-1">Senha</p>

              <v-span v-if="isNew">
                <v-btn
                  v-if="senha == null"
                  height="30px"
                  small
                  outlined
                  color="primary"
                  @click="gerarSenha()"
                  >Gerar senha</v-btn
                >

                <v-span v-else-if="senha != null">
                  <v-row>
                    <v-col cols="5" class="px-1 py-0 mx-4 my-0">
                      <v-row>
                        <span class="headline">{{ senha }}</span>
                      </v-row>
                      <v-row>
                        <span style="color: green">{{
                          msgSenha ? "Senha copiada com sucesso" : ""
                        }}</span>
                      </v-row>
                    </v-col>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          icon
                          small
                          color="primary"
                          @click="copiarSenha()"
                        >
                          <v-icon small v-if="!msgSenha">fa-clone</v-icon>
                          <v-icon small v-else-if="msgSenha">fa-check</v-icon>
                        </v-btn>
                      </template>
                      <span>Copiar  </span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          icon
                          small
                          color="primary"
                          @click="gerarSenha()"
                        >
                          <v-icon small>fa-retweet</v-icon>
                        </v-btn>
                      </template>
                      <span>Gerar senha</span>
                    </v-tooltip>
                  </v-row>
                </v-span>
              </v-span>

              <v-btn
                height="30px"
                small
                v-else-if="!isNew"
                outlined
                color="primary"
                @click="resetPassword(formData)"
                >Redefinir senha</v-btn
              >
            </v-col>

          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="px-1">
        <v-btn height="30px" small outlined color="primary" @click="close(null)"
          >cancelar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          height="30px"
          small
          depressed
          color="primary"
          @click="validateForm"
          >Salvar</v-btn
        >
      </v-card-actions>
    </v-card>
    <!-- <Footer /> -->
  </v-container>
</template>

<script>
const initialData = {
  UsuarioTradimus: false,
  Nome: "",
  UserName: "",
  Email: "",
  PhoneNumber: null,
  IsActive: true,
  IsMFARequired: null,
  Prestadores: [],
  Permissao: {},
  grupo_economico: null,
  senha: null,
  IsPasswordLoginDisabled: null,
};
import { mapState, mapGetters } from "vuex";
import UsersProfilesForm from "@/components/config/UsersProfilesForm";
export default {
  components: {
    UsersProfilesForm,
  },
  data() {
    return {
      formData: {},
      prestadoresList: [],
      profileText: "Clique no lápis para editar.",
      passwordDefault: process.env.VUE_APP_DEFAULT_PWD,
      showProfileDialog: false,
      userFormValid: true,
      invalidProfile: false,
      statusUser: true,
      showPhone: true,
      searchInput: null,
      senha: null,
      msgSenha: false,
      PasswordGenerated: false,
      parametrizacoes: {},
      currentUser: {},
    };
  },
  watch: {
    open(val) {
      this.senha = null
      this.msgSenha = false
      this.invalidProfile = false;
      this.showPhone = false;
      this.$refs.userForm.reset();
      if (val) {
        this.prestadoresList = this.getPrestadoresByGeco();
        this.formData = !this.isNew? Object.assign(this.formData, this.item) : this.formData;
        this.formData.grupo_economico = this.isNew ? this.grupoEconomico : this.item.grupo_economico;
        this.formData.IsMFARequired = !this.isNew ? (this.item.IsMFARequired ?? null) : null;
        this.statusUser = this.formData.IsActive;
        if (!this.isNew && !this.item.Prestadores.length) {
          this.formData.Prestadores = this.prestadoresList.map((el) => el.id);
        }
        this.$nextTick(() => {
          this.showPhone = true;
          this.$refs.userForm.resetValidation();
          this.stringifyPermissao(this.formData.Permissao);
        });
      } else {
        Object.keys(this.formData.Permissao).forEach((mod) => {
          this.formData.Permissao[mod] = [];
        });
      }
    },
    IsActive(val) {
      this.statusUser = val;
      this.formData.IsActive = val;
    },
  },
  created() {
    this.formData = { ...initialData };
  },
  mounted() {
    this.$refs.userForm.reset();
    this.PasswordGenerated = false;
    this.getParametrizacoes();
    this.getSelfUser();
  },
  computed: {
    ...mapState({
      isTradimus: (state) => state.userData.userData.UsuarioTradimus,
      formRules: (state) => state.formRules,
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      modulosTitles: (state) => state.permissions.modulosTitles,
      gruposAcessoTitles: (state) => state.permissions.gruposAcessoTitles,
      permissaoBase: (state) => state.permissions.permissaoBaseCadastro,
    }),
    ...mapGetters({
      getPrestadoresByGeco: "permissions/getPrestadoresByGeco",
    }),
    isAllSelected() {
      if (this.formData && this.formData.Prestadores) {
        return this.prestadoresList.length == this.formData.Prestadores.length;
      } else {
        return false;
      }
    },
    shouldShowMFASwitch() {
      return this.parametrizacoes.PLT_MULTIPLO_FATOR_DE_AUTENTICACAO_HABILITADO ?? false;
    },
    shouldShowDisalbePasswordLoginSwitch() {
      return this.parametrizacoes.PLT_LOGIN_SEM_SENHA_HABILITADO ?? false;
    },
    shouldShowGeneratePasswordButton() {
      if(this.isNew || !this.item.IsPasswordLoginDisabled)
      {
        return !this.formData.IsPasswordLoginDisabled;
      }


      return false;
    },
    isEditingSelf() {
      return !this.isNew && this.currentUser.Id && this.formData.Id && this.currentUser.Id === this.formData.Id;
    }, 
  },
  methods: {
    getParametrizacoes() {
      let opts = {
        query: [
          {
            Modulo: "Portal",
            Acao: "getparametrizacoes",
            Payload: {
              grupo_economico: this.grupoEconomico
            },
          },
        ],
        noLoader: true,
      };
      this.$store.dispatch("request/doRequest", opts).then(resp => {
        this.parametrizacoes = resp.parametros || {};
      }).catch(err => {
        console.error('Erro ao buscar parametrizações:', err);
        this.parametrizacoes = {};
      });
    },
    getSelfUser() {
      let opts = {
        query: [
          {
            Modulo: "portal",
            Acao: "getselfuser",
            Payload: {},
          },
        ],
        noLoader: true,
      };
      this.$store.dispatch("request/doRequest", opts).then(resp => {
        this.currentUser = resp || {};
      }).catch(err => {
        console.error('Erro ao buscar usuário logado:', err);
        this.currentUser = {};
      });
    },
    gerarSenha() {
      this.msgSenha = false;
      this.PasswordGenerated = true;
      this.senha = this.genSenha();

      this.formData.senha = this.senha;

      let paramModal = {
        type: "warning",
        title: `Senha gerada`,
        message: `Após salvar, a senha não será mais exibida. <br>Anote a senha para que possa ser utilizada no seu primeiro acesso.<br> `,
        callback: () => {},
        btConfirm: { name: "Ok", show: true },
        btCancel: { name: "Não", show: false },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    copiarSenha() {
      
      navigator.clipboard.writeText(this.senha);
      this.msgSenha = true;

    },
    toggleAutocomplete(item, campo) {
      this.searchInput = null;
      let index = this.formData[campo].indexOf(item.id);
      //  index > -1  está excluindo a operadora
      if (index > -1) {
        this.formData[campo].splice(index, 1);
      } else {
        //  index < 0  está adicionando a operadora
        this.formData[campo].push(item.id);
      }
      this.$nextTick();
      return;
    },
    toggleAllPrestadores() {
      this.searchInput = null;
      if (!this.isAllSelected) {
        this.formData.Prestadores = this.prestadoresList.map((el) => el.id);
      } else {
        this.formData.Prestadores = [];
      }
    },
    closeProfileForm(profile) {
      if (profile && profile.Permissao) {
        this.invalidProfile = false;
        this.PasswordGenerated=false;
        this.formData.Permissao = profile.Permissao;
        this.formData.UsuarioTradimus = profile.UsuarioTradimus;
        this.stringifyPermissao(profile.Permissao);
        this.showProfileDialog = false;
      } else {
        this.invalidProfile = !this.stringifyPermissao(this.formData.Permissao);
        this.showProfileDialog = false;
      }
    },
    stringifyPermissao(Permissao) {
      if (!Permissao) {
        this.profileText = "Clique no lápis para editar.";
        return false;
      }
      if (typeof Permissao == "string") {
        Permissao = JSON.parse(Permissao);
      }
      let hasPermission = Object.values(Permissao).find((mod) => mod.length);
      if (hasPermission) {
        let profiles = [];
        if (Permissao.portal.includes("usuario")) {
          let ind = Permissao.portal.findIndex((el) => el == "usuario");
          Permissao.portal.splice(ind, 1);
        }
        // if (
        //   Object.keys(Permissao).includes("portal") &&
        //   Permissao.portal.includes("administrador")
        // ) {
        //   let grupoAcessoNome = this.gruposAcessoTitles[
        //     "administrador"
        //   ].toUpperCase();
        //   profiles.push(grupoAcessoNome);
        // }
        Object.entries(Permissao).forEach((mod) => {
          if (mod[1] && mod[1].length) {
            //(mod[0] != "portal" && mod[1].length)
            let grupoAcessoList = mod[1].map((grupoAcesso) => {
              let perfil =
                this.gruposAcessoTitles && this.gruposAcessoTitles[grupoAcesso]
                  ? this.gruposAcessoTitles[grupoAcesso].toLowerCase()
                  : grupoAcesso;
              return perfil;
            });
            if (this.modulosTitles[mod[0]]) {
              profiles.push(
                this.modulosTitles[mod[0]].toUpperCase() +
                  " (" +
                  grupoAcessoList.join(", ") +
                  ")"
              );
            }
          }
        });
        this.profileText = profiles.join(", ") + ".";
        return profiles.length;
      } else {
        this.profileText = "Clique no lápis para editar.";
        return false;
      }
    },
    beforeToogleStatus(val) {
      this.toogleStatus(this.formData);
      this.statusUser = !val;
    },
    remove(item) {
      const index = this.formData.Prestadores.indexOf(item.id);
      if (index >= 0) this.formData.Prestadores.splice(index, 1);
    },
    async sanitizePermissao(Permissao) {
      if (!Permissao.portal.includes("usuario")) {
        Permissao.portal.push("usuario");
      }
      let permissoesPorModulo = this.$store.state.permissions.permissaoInicial;
      let modulos = Object.keys(Permissao);
      await modulos.forEach((modulo) => {
        if (Permissao[modulo] && Permissao[modulo].length > 0) {
          if (
            !Permissao[modulo].includes("usuario") &&
            permissoesPorModulo[modulo].includes("usuario")
          ) {
            Permissao[modulo].push("usuario");
          }
        } else {
          delete Permissao[modulo];
        }
        return Permissao;
      });
      return Permissao;
    },
    validateForm() {
      if (
        !this.formData.IsPasswordLoginDisabled
        && this.isNew
        && !this.PasswordGenerated
      ) {
        let paramModal = {
          type: "warning",
          title: `Gerar Senha Nova`,
          message: "Necessário clicar no botão gerar senha antes de salvar.",
          callback: () => {},
          btConfirm: { name: "Ok", show: true },
          btCancel: { name: "Não", show: false },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      } else {
        if (!this.stringifyPermissao(this.formData.Permissao)) {
          this.invalidProfile = true;
          this.$refs.userForm.validate();
          return;
        }

        if (
          this.$refs.userForm.validate() &&
          !this.invalidProfile &&
          this.formData.Prestadores.length
        ) {
          let form = { ...this.formData };
          form.PhoneNumber = this.formData.PhoneNumber
            ? Number(this.formData.PhoneNumber.replace(/[^0-9]/g, ""))
            : null;

          if (!this.shouldShowMFASwitch) {
            form.IsMFARequired = null;
          }

          if (!this.shouldShowDisalbePasswordLoginSwitch) {
            form.IsPasswordLoginDisabled = null;
          }

          if (this.isAllSelected) {
            form.Prestadores = [];
          }

          const isMFAActivated = !this.currentUser.IsMFARequired && form.IsMFARequired && this.isEditingSelf;

          this.sanitizePermissao(this.formData.Permissao).then((resp) => {
            form.Permissao = resp;

            this.close(form);

            if (isMFAActivated) {
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          });
        }
      }
    },
  },
  props: {
    close: Function,
    IsActive: Boolean,
    isNew: Boolean,
    item: Object,
    open: Boolean,
    resetPassword: Function,
    toogleStatus: Function,
    genSenha: Function,
  },
};
</script>

<style>
</style>
